import React from 'react';

const OrderNotes = ({ notes, handleInputChange }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="font-bold text-lg mb-5 pb-3 border-b border-gray-200">Бележки към поръчката</h3>
      <div className="mb-4">
        <label htmlFor="notes" className="block mb-1 font-medium">Бележки (незадължително)</label>
        <textarea
          id="notes"
          name="notes"
          value={notes}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent min-h-[120px] resize-y"
          placeholder="Специални инструкции за вашата поръчка"
        ></textarea>
      </div>
    </div>
  );
};

export default OrderNotes; 